/**
 * Whose desk the Quality door shows (proposal 12 E2E, kanban 0aac3112).
 * The door's queue rule matches the viewer's name against `routed_to`
 * (threadTriageView.isRoutedToUser), and answers read "asked … for <name>".
 * An admin is not on the quality team, so for them the door uses the desk's
 * home person's name instead (GET /api/quality-copilot/desk says when).
 */
import type { DoorDeskRead } from '../../services/qcpDesk';

/** The name the door's queue, lanes and "for <name>" wording use. */
export function deskQueueName(desk: DoorDeskRead | null, viewerName: string | null): string | null {
  if (desk?.viewing_as_home && desk.home_name.trim()) return desk.home_name.trim();
  return viewerName;
}

/** "Viewing Jess Finlaw's desk" under the tab bar, or null on one's own desk. */
export function deskViewingLine(desk: DoorDeskRead | null): string | null {
  if (!desk?.viewing_as_home || !desk.home_name.trim()) return null;
  return `Viewing ${desk.home_name.trim()}'s desk`;
}
